const YouNext = () => (
    <section id="you-next">
        <div className="container-fluid pt-2 pb-4 text-center gg-bg-solid-green-light">
            <div className="row justify-content-center align-content-center text-center py-3 gg-bg-solid-green text-white">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-11">
                    <h1 className="fw-bold">What If You Could Be Next?</h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center mt-5">
                <div className="col-xl-6 col-lg-7 col-md-8 col-11 text-md-start text-center">
                    <p>I was where you are now. Exhausted. Numb. Managing, not living.</p>
                    <p>But when I followed Dr. Hart’s protocol, everything changed.</p>
                    <p>
                        ✔️ I woke up feeling clear, steady — like my body was finally on my side.<br />
                        ✔️ I ate without obsessing over every bite.<br />
                        ✔️ I enjoyed dessert without fear or regret.<br />
                        ✔️ I dropped stubborn weight — no extreme diets, no workouts.<br />
                        ✔️ I felt the tingling fade in my hands and feet.<br />
                        ✔️ I looked in the mirror and saw life coming back into my face.<br />
                        ✔️ I heard my doctor say, “You’re no longer dependent on this medication.”
                    </p>
                    <p>Now, ask yourself…</p>
                    <p>What would that be worth?</p>
                    <p>Because type 2 diabetes is already costing you:</p>
                    <p>
                        – <b>$36,000</b> in treatment over just a few years<br />
                        – <b>$12,000</b> for one hospital visit<br />
                        – <b>$1,000–$2,000</b>/year in supplies and checkups
                    </p>
                    <p>And that’s <i>before</i> you count the emotional toll.</p>
                    <p>But Dr. Hart refuses to let this be a rich man’s solution.</p>
                    <p>He’s not asking $297 a bottle. Not $200. Not even $100.</p>
                    <p>Today, you can get your first bottle of <b>GlucoGen<sup>17</sup> Naturals</b> for as little as <b>$1.63 per day</b>.</p>
                    <p>
                        That’s less than a box of test strips. Less than one takeout meal.<br />
                        And it includes more than just the formula.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default YouNext;